export default function CardDinamic({children}){
    console.log(children)
    return (
        <div className="card-dinamic">
            {children}
        </div>
    )
}